import { render, staticRenderFns } from "./task_setdevice.vue?vue&type=template&id=981f16fa&scoped=true"
import script from "./task_setdevice.vue?vue&type=script&lang=js"
export * from "./task_setdevice.vue?vue&type=script&lang=js"
import style0 from "./task_setdevice.vue?vue&type=style&index=0&id=981f16fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981f16fa",
  null
  
)

export default component.exports